export default {
    leadId: null,
    leads: [],
    siblingAccounts: [],
    loading: false,
    opened: false,
};
